var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 27.5,
    fill: "#535353"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2075_257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2075_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 51.3367C31.6667 52.919 33.4172 53.8747 34.7483 53.019L52.3831 41.6824C53.6077 40.8951 53.6077 39.1049 52.3831 38.3177L34.7483 26.981C33.4172 26.1253 31.6667 27.081 31.6667 28.6634V51.3367ZM40.0001 73.3334C35.389 73.3334 31.0556 72.4584 27.0001 70.7084C22.9445 68.9584 19.4167 66.5834 16.4167 63.5834C13.4167 60.5834 11.0417 57.0556 9.29175 53C7.54175 48.9445 6.66675 44.6111 6.66675 40C6.66675 35.3889 7.54175 31.0556 9.29175 27C11.0417 22.9445 13.4167 19.4167 16.4167 16.4167C19.4167 13.4167 22.9445 11.0417 27.0001 9.29169C31.0556 7.54169 35.389 6.66669 40.0001 6.66669C44.6112 6.66669 48.9445 7.54169 53.0001 9.29169C57.0556 11.0417 60.5834 13.4167 63.5834 16.4167C66.5834 19.4167 68.9584 22.9445 70.7084 27C72.4584 31.0556 73.3334 35.3889 73.3334 40C73.3334 44.6111 72.4584 48.9445 70.7084 53C68.9584 57.0556 66.5834 60.5834 63.5834 63.5834C60.5834 66.5834 57.0556 68.9584 53.0001 70.7084C48.9445 72.4584 44.6112 73.3334 40.0001 73.3334ZM40.0001 66.6667C47.4445 66.6667 53.7501 64.0834 58.9168 58.9167C64.0834 53.75 66.6667 47.4445 66.6667 40C66.6667 32.5556 64.0834 26.25 58.9168 21.0834C53.7501 15.9167 47.4445 13.3334 40.0001 13.3334C32.5556 13.3334 26.2501 15.9167 21.0834 21.0834C15.9167 26.25 13.3334 32.5556 13.3334 40C13.3334 47.4445 15.9167 53.75 21.0834 58.9167C26.2501 64.0834 32.5556 66.6667 40.0001 66.6667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.3b5e9d27c40b68ae54b2d8dc2f249bdb.svg";
export { ForwardRef as ReactComponent };